import React, { useLayoutEffect, useState } from 'react';
import { Box, Paper, Tab, Tabs, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import LoanInventoryModule from './store/LoanInventoryModule';
import LoanInModule from './store/LoanInModule';
import LoanOutModule from './store/LoanOutModule';
import WorkflowGuide from './common/WorkflowGuide';

const Loan = () => {
  const location = useLocation();
  const [tabValue, setTabValue] = useState(0);

  useLayoutEffect(() => {
    const t = location.state?.loanTab;
    if (typeof t === 'number') {
      setTabValue(t);
    }
  }, [location.state?.loanTab]);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Loan
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Record loan-in and loan-out activity, and review loan history with due dates and outstanding balances.
      </Typography>
      <WorkflowGuide variant="loan" />

      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={tabValue}
          onChange={(_, newValue) => setTabValue(newValue)}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Loan History" />
          <Tab label="Loan In" />
          <Tab label="Loan Out" />
        </Tabs>
      </Paper>

      {tabValue === 0 && (
        <LoanInventoryModule
          title="Loan History"
          infoMessage="Loan history tracks borrowed and loaned lines with due dates, returns, and outstanding balances."
          emptyMessage="No loan history records found"
          loadErrorMessage="Failed to load loan history"
        />
      )}
      {tabValue === 1 && <LoanInModule />}
      {tabValue === 2 && <LoanOutModule />}
    </Box>
  );
};

export default Loan;
